import { template as template_fd9b2463e5f141cfb5666b64daa1f11a } from "@ember/template-compiler";
import element from 'ember-element-helper/helpers/element';
import classNames from 'volta/helpers/class-names';
import or from 'ember-truth-helpers/helpers/or';
import { fn } from '@ember/helper';
import Component from '@glimmer/component';
import BvMenuItem, { type BvMenuItemSignature } from 'volta/components/bv-menu/item';
import type { IBvMenuItem } from 'volta/components/bv-menu';
import type { ComponentLike } from '@glint/template';
interface BvMenuSectionSignature {
    Args: {
        // Collection of action items
        section?: any;
        // Whether the parent action list has multiple sections
        hasMultipleSections?: boolean;
        onAnyItemAction?: (event: Event) => void;
    };
    Blocks: {
        default: [ComponentLike<BvMenuItemSignature>];
        title: [];
    };
}
export default class BvMenuSectionComponent extends Component<BvMenuSectionSignature> {
    onItemAction = (item: IBvMenuItem, event: Event)=>{
        event.preventDefault();
        event.stopPropagation();
        item.onClick?.(event);
        this.args.onAnyItemAction?.(event);
    };
    static{
        template_fd9b2463e5f141cfb5666b64daa1f11a(`
    {{#let (element (if @hasMultipleSections 'li' 'div')) as |Tag|}}
      <Tag
        class={{classNames
          'bv-menu-section'
          (unless @section.title 'bv-menu-section--without-title')
        }}
      >
        {{#if (or @section.title (has-block 'title'))}}
          <p class='bv-menu-title'>
            {{#if @section.title}}
              {{@section.title}}
            {{else}}
              {{yield to='title'}}
            {{/if}}
          </p>
        {{/if}}
        <ul class='bv-menu__items'>
          {{#if (has-block)}}
            {{yield (component BvMenuItem)}}
          {{else}}
            {{#each @section.items as |item|}}
              {{#if item}}
                <BvMenuItem @item={{item}} @onClick={{fn this.onItemAction item}} />
              {{/if}}
            {{/each}}
          {{/if}}
        </ul>
      </Tag>
    {{/let}}
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
declare module '@glint/environment-ember-loose/registry' {
    export default interface Registry {
        'BvMenu::Section': typeof BvMenuSectionComponent;
        'bv-menu/section': typeof BvMenuSectionComponent;
    }
}
